import React from "react";
import './Loader.scss'

const Loader = () => {
  return (
    <div className="loader-container"
      
    >
      <div className="loader-container__loader"></div>
    </div>
  );
};

export default Loader;